import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import usePageSeo from "../hooks/usePageSeo";
import { resolveSeoByLocation } from "./routeSeoConfig";
import { trackYandexPageView } from "../utils/yandexMetrika";

export default function RouteSeoManager() {
    const location = useLocation();
    const isInitialLocationRef = useRef(true);
    const previousUrlRef = useRef(typeof window !== "undefined" ? window.location.href : "");

    const seoMeta = useMemo(
        () =>
            resolveSeoByLocation({
                pathname: location.pathname,
                search: location.search,
            }),
        [location.pathname, location.search]
    );

    // Shared pages own dynamic metadata. Keep the server's photo/title while loading.
    const isSharedTravel = /^\/travel\/shared\/[^/]+\/?$/.test(location.pathname);
    const isPublicRoute = /^\/marshruty\/[^/]+\/[^/]+\/?$/.test(location.pathname);
    const isEditorialPage = /^\/chto-posmotret\/[^/]+\/?$/.test(location.pathname);
    usePageSeo({ ...seoMeta, enabled: !isSharedTravel && !isPublicRoute && !isEditorialPage });

    useEffect(() => {
        if (typeof window === "undefined") return;

        const currentUrl = window.location.href;
        if (isInitialLocationRef.current) {
            isInitialLocationRef.current = false;
            previousUrlRef.current = currentUrl;
            return;
        }

        const referer = previousUrlRef.current;
        trackYandexPageView(currentUrl, referer ? { referer } : {});
        previousUrlRef.current = currentUrl;
    }, [location.hash, location.pathname, location.search]);

    return null;
}
